export default __webpack_public_path__ + "static/media/inseamLenghMeasurement.15f6ac3e.jpeg";